import { createRoot } from 'react-dom/client'
import Scene from './Scene'
import Overlay from './Overlay/Overlay'
import Loader from './Loader/Loader'
import Lenis from '@studio-freight/lenis'

const root = createRoot(document.getElementById('root'))

const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  touchMultiplier: 1.2,
  smoothTouch: true,
  syncTouch: true,
  syncTouchLerp: 0.1
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

root.render(
  <>
    <Scene />
    <Overlay />
    <Loader />
  </>
)
